import {typography} from "./AppTypography";
import {DarkPalette} from "./DarkPalette";
import {LightPalette} from "./LightPalette";
import {ITheme} from "../interfaces/themes/ITheme";
import {createTheme} from "@mui/material";

export function createAppTheme(isDark: boolean) {
    const palette = isDark ? DarkPalette : LightPalette
    const tempTheme = createTheme({palette}) as ITheme;
    return createTheme({
            components: {
                MuiButton: {
                    variants: [
                        {
                            props: {variant: 'contained'},
                            style: {
                                '&:hover': {},
                            },
                        },
                        {
                            props: {variant: 'text'},
                            style: {
                                '&:hover': {
                                    backgroundColor: 'rgba(0,0,0,0.1)'
                                },
                            },
                        },
                    ],
                    styleOverrides: {
                        root: {
                            textTransform: 'none',
                            color: palette.text.secondary
                        }
                    },
                },
                MuiMenuItem: {
                    styleOverrides: {
                        root: {
                            color: '#222222' // todo move?
                        }
                    },
                },
                MuiMenu: {
                    styleOverrides: {
                        root: {
                            color: '#222222' // todo move?
                        }
                    },
                },
                MuiSelect: {
                    defaultProps: {
                        MenuProps: {
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                        },
                    },
                    styleOverrides: {
                        root: {
                            color: palette.text.secondary,
                            "&.Mui-focused": {
                                color: palette.text.secondary,
                            },
                            "&:after": {
                                borderBottomColor: palette.text.secondary,
                            },
                            "& .MuiSvgIcon-root": {
                                color: palette.text.secondary,
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "transparent !important",
                            },
                        },
                    }
                },
                MuiSwitch: {
                    styleOverrides: {
                        root: {}
                    }
                },
                MuiFormControlLabel: {
                    styleOverrides: {
                        root: {
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                            },
                        },
                    },
                },
                MuiTextField: {
                    defaultProps: {
                        InputLabelProps: {
                            shrink: true,
                        },
                    },
                    styleOverrides: {

                        root: {
                            backgroundColor: palette.primary.main,
                            borderRadius: 8, // todo
                            color: palette.text.secondary,
                            '& .MuiInputBase-input': {
                                color: 'white',
                            },
                            '& .MuiInputLabel-root': {
                                color: 'white',
                            },
                            fieldset: {
                                borderRadius: 8,
                            },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: 'transparent', // Default border color
                                },
                                '&:hover fieldset': {
                                    borderColor: palette.text.tertiary,
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: palette.text.tertiary,
                                },
                            },
                        },
                    },
                },
                MuiInputBase: {
                    styleOverrides: {
                        input: {
                            '&::placeholder': {
                                color: 'white',
                                opacity: 0.8,
                            },
                        },
                    },
                },
                MuiTabs: {
                    defaultProps: {
                        TabIndicatorProps: {
                            style: {
                                display: 'none',
                            },
                        },
                    },
                    styleOverrides: {

                        root: {
                            display: 'flex',
                            alignItems: 'center',
                            '& .MuiTab-root': {
                                marginRight: 32, // Adjust the gap between tabs here
                            },
                            '& .MuiTab-root:last-child': {
                                marginRight: '0', // Remove the margin from the last tab if needed
                            },
                        }
                    }
                },
                MuiTab: {
                    defaultProps: {
                        disableRipple: true,
                    },
                    styleOverrides: {
                        root: {
                            backgroundColor: palette.primary.main,
                            color: palette.text.secondary,
                            borderRadius: 8,
                            textTransform: 'none',
                            margin: 6,
                            boxShadow: tempTheme.palette.shadow.main,

                            indicator: {
                                display: 'none',
                                backgroundColor: 'transparent',
                            },
                            '&:hover': {
                                boxShadow: tempTheme.palette.shadow.hover,
                                transform: 'translate(-1px, 1px)',
                            },
                            '&.Mui-selected': {
                                color: palette.text.secondary,
                                boxShadow: 'inset -4px 4px 0px #0000006f, inset 2px -2px 4px #0000002f',
                                transform: 'translate(-2px, 2px)',
                            },
                            '&:active': {
                                boxShadow: 'inset -4px 4px 0px #0000006f, inset 2px -2px 4px #0000002f',
                                transform: 'translate(-2px, 2px)',
                            },

                            [tempTheme.breakpoints.only('xs')]: {
                                width: 130,
                                fontSize: 18,
                            },
                            [tempTheme.breakpoints.up('sm')]: {
                                width: 150,
                                fontSize: 18,
                            },
                        },
                    },
                },
                MuiCollapse: {
                    styleOverrides: {
                        root: {
                            //marginLeft: 32,
                        },
                    },
                },
            },
            spacing: 8,
            palette: palette,
            typography: typography(tempTheme),
        }
    )
}
